import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const scrollToElement = () => {
            if (hash) {
                // Remove the '#' from the hash
                const id = hash.replace('#', '');
                const element = document.getElementById(id);
                
                if (element) {
                    // Try scrolling with smooth behavior first
                    try {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    } catch (error) {
                        // Fallback to regular scroll if smooth scroll fails
                        element.scrollIntoView();
                    }
                }
            } else {
                window.scrollTo(0, 0);
            }
        };

        // Try immediately
        scrollToElement();
        
        // And also after a short delay to ensure DOM is ready
        const timeoutId = setTimeout(scrollToElement, 500);

        return () => clearTimeout(timeoutId);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
